import React from 'react';
import * as S from './ThingsYouShouldKnow.styles';
import MegaPhoneIcon from '../../../../Icons/MegaPhoneIcon';
import {CheckBox} from '../../common/CheckBox/CheckBox';
import styled from 'styled-components';

const ThingsYouShouldKnow: React.FC<{
  list: Array<string>;
  tncAgreement?: boolean;
  showCheckBox?: boolean;
  onCheckBoxClick?: Function;
}> = ({list = [], tncAgreement = true, showCheckBox = false, onCheckBoxClick = () => {}}) => {
  if (!list.length) {
    return null;
  }

  return (
    <S.ThingsYouShouldKnowWrapper>
      <S.TitleOuterWrapper>
        <MegaPhoneIcon />
        <S.TitleWrap>Things you should know</S.TitleWrap>
      </S.TitleOuterWrapper>
      <S.ThingsListItem>
        {list.map(item => (
          <li>{item}</li>
        ))}
      </S.ThingsListItem>
      {showCheckBox && (
        <S.CheckBoxEntryWrapDiv>
          <StyledCheckBox checked={tncAgreement} onChange={onCheckBoxClick} />
          <S.TitleTxtWrapSpan>I Agree to Terms & Conditions</S.TitleTxtWrapSpan>
        </S.CheckBoxEntryWrapDiv>
      )}
    </S.ThingsYouShouldKnowWrapper>
  );
};

export default ThingsYouShouldKnow;

const StyledCheckBox = styled(CheckBox)(
  props => `
  transform: scale(1.3);
  margin-right: 1rem;
    margin-top: 0.4rem;
`,
);
